import { useI18n } from "../lib/i18n";

const CLS = {
  received_from_supplier: "bg-rose-100 text-rose-800 border-rose-300",
  received_from_inventory: "bg-emerald-100 text-emerald-800 border-emerald-300",
  returned_to_supplier: "bg-orange-100 text-orange-800 border-orange-300",
};

export const StatusBadge = ({ status, testId }) => {
  const { t } = useI18n();
  return <span data-testid={testId} className={`inline-block text-xs font-bold border rounded-full px-2.5 py-0.5 ${CLS[status] || CLS.received_from_inventory}`}>{t(status)}</span>;
};
